import { AdminUserStatsSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type AdminUserStats = AdminUserStatsSchema;

/**
 * Get all users with their statistics for admin dashboard
 */
export const getAdminUsersStats = async (): Promise<{ usersStats: AdminUserStats[] }> => {
  const response = await apiClient.get<{ usersStats: AdminUserStats[] }>("/api/admin/users-stats");
  return response.data;
};

/**
 * Delete a user by ID (admin only)
 */
export const adminDeleteUser = async (userId: string): Promise<{ userId: string }> => {
  const response = await apiClient.delete<{ userId: string }>(`/api/admin/users/${userId}`);
  return response.data;
};

export interface AdminRevenueStats {
  mrr: number;
  stripeMrr: number;
  storeMrr: number;
  currentMonthRevenue: number;
  currentMonthStripeRevenue: number;
  currentMonthStoreRevenue: number;
  lastMonthRevenue: number;
  lastMonthStripeRevenue: number;
  lastMonthStoreRevenue: number;
  revenueGrowth: number;
  activeSubscriptions: number;
  stripeActiveSubscriptions: number;
  storeActiveSubscriptions: number;
  currency: string;
}

/**
 * Get combined revenue statistics from Stripe and RevenueCat
 */
export const getAdminRevenueStats = async (): Promise<{ revenueStats: AdminRevenueStats }> => {
  const response = await apiClient.get<{ revenueStats: AdminRevenueStats }>("/api/admin/revenue-stats");
  return response.data;
};
